<template>
  <NavBarGroup
    v-if="workspacePins.length > 0"
    label="PINNED"
  >
    <NavBarWorkspacePin
      v-for="pin in workspacePins"
      :key="pin.id"
      :title="pin.title"
      :type="pin.type"
      :path="pin.path"
      @unpin="pin.id && userPinsStore.deleteUserPin(pin.id)"
    />
  </NavBarGroup>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUserPinsStore } from '~/stores/user/user-pins'

const userPinsStore = useUserPinsStore()

const { workspacePins } = storeToRefs(userPinsStore)
</script>
